import {ComponentPropsWithoutRef} from "react";

interface CellProps extends ComponentPropsWithoutRef<'td'> {}

export default function Cell(props: CellProps) {
  return <td {...props} />
}